<div [@pageLoad]="pageLoadState" class="h-[100%] relative">
  <div
    class="gap-[40px] flex flex-col justify-around items-center pl-[64px] pr-[64px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] h-[100%]">
    <div
      class="gap-[80px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch grow basis-0 pt-[120px] pb-[120px]">
      <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
        <div class="gap-[16px] flex flex-col shrink-0 justify-start items-center">
          <span
            class="shrink-0 text-[#111215] text-center font-bold font-['archivo'] text-[24px] leading-[32px] tracking-[-0.01em]">
            {{ titleText }}
          </span>
          <span
            class="w-full max-w-[700px] shrink-0 text-[#444955] text-center font-normal font-['archivo'] text-[20px] leading-[28px]">
            {{ subtitleText }}
          </span>
        </div>

        <div
          class="gap-[20px] flex flex-row w-[100%] shrink-0 justify-center items-stretch self-stretch flex-wrap px-[48px]">
          <button
            *ngFor="let option of dateOptions; let i = index"
            type="button"
            (click)="toggleDate(i)"
            (keydown)="handleCardKeyDown($event, i)"
            [attr.aria-pressed]="option.selected"
            [attr.aria-label]="'Select date ' + option.dateLabel"
            class="flex flex-col w-[260px] cursor-pointer shrink-0 rounded-[16px] justify-start items-start focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#5BA5F54D] overflow-hidden border-[2px] border-[#A1A4AA] transition duration-150">
            <div
              class="gap-[8px] flex flex-row w-[100%] rounded-tl-[14px] border-b-[2px] border-b-[#A1A4AA] rounded-tr-[14px] shrink-0 justify-center items-center self-stretch pl-[12px] pr-[12px] pt-[12px] pb-[12px]"
              [ngClass]="{
                'bg-[#4caf50ff]': option.selected,
                'bg-[#ffffffff]': !option.selected
              }">
              <div class="gap-[8px] flex flex-row w-[100%] shrink-0 justify-center items-center grow basis-0">
                <span
                  class="shrink-0 text-center font-normal font-['archivo'] text-[18px] uppercase leading-[32px]"
                  [ngClass]="{
                    'text-[#ffffffff]': option.selected,
                    'text-[#444955ff]': !option.selected
                  }">
                  {{ option.dayLabel }}
                </span>
                <div
                  *ngIf="option.selected"
                  class="gap-[8px] flex flex-row w-[24px] h-[24px] shrink-0 rounded-[100px] justify-end items-start pl-[4px] pr-[2px] pt-[2px] pb-[4px] bg-[#088242]">
                  <img
                    src="assets/icons/check.svg"
                    alt="Selected date checkmark"
                    loading="lazy"
                    decoding="async"
                    class="w-[20px] h-[20px] shrink-0" />
                </div>
              </div>
            </div>

            <div
              class="gap-[8px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch pl-[14px] pr-[14px] pt-[16px] pb-[16px] relative grow"
              [ngClass]="{
                'bg-[#f2f5f7ff]': option.selected,
                'bg-[#ffffffff]': !option.selected
              }">
              <span
                class="w-[100%] text-[#111215ff] text-center font-bold font-['archivo'] text-[22px] leading-[26px]">
                {{ option.dateLabel }}
              </span>
              <div
                *ngIf="option.hotMenuText || option.coldMenuText"
                class="flex flex-col w-full gap-[6px] pt-[4px] items-start text-left">
                <span
                  *ngIf="option.hotMenuText"
                  class="w-full text-[#444955] font-['archivo'] font-normal text-[12px] leading-[16px]">
                  {{ hotLabel }}: {{ option.hotMenuText }}
                </span>
                <span
                  *ngIf="option.coldMenuText"
                  class="w-full text-[#444955] font-['archivo'] font-normal text-[12px] leading-[16px]">
                  {{ coldLabel }}: {{ option.coldMenuText }}
                </span>
              </div>
            </div>
          </button>
        </div>

        <span
          *ngIf="dateOptions.length === 0"
          class="text-[#444955] text-center font-archivo text-[18px]">
          {{ emptyText }}
        </span>
      </div>
    </div>

    <div class="gap-[8px] flex flex-row w-[100%] shrink-0 justify-between items-center self-stretch">
      <NiButton
        variant="outlined"
        color="secondary"
        size="Large"
        [label]="backLabel"
        leadingIcon="arrowNarrowLeft"
        [px]="'[24px]'"
        [py]="'[16px]'"
        [rounded]="'[999px]'"
        border="1"
        borderColor="[#5BA5F5]"
        bg="transparent"
        (onClick)="onBack()"
        [styleClass]="
          'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
          `'archivo'] text-[18px] leading-[23px]'`">
      </NiButton>

      <NiButton
        variant="contained"
        color="primary"
        size="large"
        [label]="applyLabel"
        [px]="'[24px]'"
        [py]="'[16px]'"
        [rounded]="'[999px]'"
        bg="[#f26f24ff]"
        textColor="#ffffff"
        (onClick)="onApply()"
        [styleClass]="
          'flex flex-row items-center gap-[12px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
          `'archivo'] text-[18px] leading-[23px] px-[32px] py-[12px]'`">
      </NiButton>
    </div>
  </div>
</div>

<NiAlert
  *ngIf="toasterMessage"
  [isVisible]="true"
  [message]="toasterMessage"
  [variant]="toasterVariant"
  [position]="'top-right'"
  [dismissible]="true"
  [duration]="4000"
  (onClose)="dismissToaster()">
</NiAlert>
